// global store
const maximiseWhiteSpaceOfParents = (child) => {
  const width = child.clientWidth;
  const height = child.clientHeight;
  const area = width * height;
  let element = child;
  let lastElement = child;
  let style = element.style || {};
  const styledHeight = (width <= 2 && height <= 2) ? '250px' : '100%';
  style.height = styledHeight;
  style.width = '100%';

  while (element.parentNode) {
    lastElement = element;
    element = element.parentNode;

    if (typeof element === 'undefined' || element === null) {
      break;
    }

    const parentNode = element && element.parentNode;
    const isElSizeSame = width === element.clientWidth && height === element.clientHeight;
    const parentIsDefined = typeof parentNode !== 'undefined' && parentNode !== null && typeof parentNode.clientWidth !== 'undefined';
    const isParentSmaller = parentIsDefined ? area > parentNode.clientWidth * parentNode.clientHeight : false;

    if (!isElSizeSame || isParentSmaller) {
      break;
    }

    style = element.style;
    style = style || {};
    style.width = '100%';
    style.height = '100%';
    style['max-width'] = 'none';
    style['max-height'] = 'none';

    if (parentIsDefined) {
      if (parentNode.style['min-width'] && parentNode.style['min-width'] !== '') style.width = parentNode.style['min-width'];
      if (parentNode.style['min-height'] && parentNode.style['min-height'] !== '') style.height = parentNode.style['min-height'];
    }
  }

  return lastElement;
};

const maximiseSafeFrame = (safeFrame) => {
  // TODO could be better.
  const supports = safeFrame.supports();
  const geom = safeFrame.geom();
  const expand = geom.exp;
  const exp = {
    r: 0,
    l: 0,
    t: 0,
    b: 0,
  };

  if (supports['exp-push']) {
    exp.t = expand.t;
    exp.b = expand.b;
    exp.push = true;
  }

  if (supports['exp-ovr'] && expand.l === expand.r) {
    exp.r = expand.r;
    exp.l = expand.l;
  }

  if (supports['exp-push'] || supports['exp-ovr']) {
    safeFrame.expand(exp);
  }
};

export const resizeWhiteSpaceOfParents = (safeFrame, canAccessIframe) => {
  const { rootElement, activeArtboard, activeArtboard: { viewport: { width } } } = store.getState();
  const scalePercentage = rootElement.clientWidth / width;

  if (canAccessIframe) {
    let thisWindow = window;
    let windowParent = thisWindow.parent;
    let iframeParent = thisWindow.frameElement.parentNode;
    let iframe = thisWindow.frameElement;
    iframe.style.height = `${activeArtboard.viewport.height * scalePercentage}px`;
  }
};

export default (rootElement, adjustHeight, revealFormat, safeFrame, canAccessIframe, mraid) => {
  if (window.mraid) {
    const maxDimensions = window.mraid.getMaxSize();
    const currentDimensions = window.mraid.getCurrentPosition();
    window.mraid.setExpandProperties({
      width: maxDimensions.width,
      height: currentDimensions.height,
      offsetY: 0,
      offsetX: 0,
      allowOffscreen: false,
    });
    window.mraid.resize();
  }

  if (safeFrame) {
    // should not white space if Ad unit can expand
    maximiseSafeFrame(safeFrame);
    return;
  }

  const state = store.getState();

  const adContainerBoundingClientRect = rootElement.getBoundingClientRect();
  const originalWidth = adContainerBoundingClientRect.width;
  const originalHeight = adContainerBoundingClientRect.height;
  let lastElement;

  if (canAccessIframe) {
    let thisWindow = window;
    let windowParent = thisWindow.parent;

    try {
      while (thisWindow !== windowParent) {
        const frame = thisWindow.frameElement;
        lastElement = maximiseWhiteSpaceOfParents(frame);
        if (!revealFormat) {
          frame.style.width = '100%';
          frame.style.maxWidth = '100%';
          frame.parentNode.style.width = '100%';
          frame.parentNode.style.height = 'auto';
          frame.parentNode.style.maxWidth = '100%';
          frame.parentNode.style.maxHeight = 'none';
          frame.parentNode.parentNode.style.width = '100%';
          frame.parentNode.parentNode.style.height = 'auto';
          frame.parentNode.parentNode.style.maxWidth = '100%';
          frame.parentNode.parentNode.style.maxHeight = 'none';
        }
        thisWindow = windowParent;
        windowParent = windowParent.parent;
      }
    } catch (e) {
      // do nothing
    }
  }

  if (lastElement && lastElement.clientWidth < originalWidth) {
    lastElement.style.width = `${originalWidth}px`;
  }

  if (lastElement && lastElement.clientHeight < originalHeight) {
    lastElement.style.height = `${originalHeight}px`;
  }
};



// WEBPACK FOOTER //
// ./app/javascript/renderer/utils/maximiseWhiteSpace.js